import styled, { ITheme } from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
    .net-upgrade {
        position: absolute;
        left: 0;
        right: 0;
        width: calc(100vw - 20px);
    }
    .box-upgrade {
        max-width: 1272px;
        width: 100%;
        margin: 0 auto;
        margin-top: 160px;
        padding-left: 120px;
        .left-upgrade {
            .main-content {
                .upgrade {
                    color: ${({ theme }: { theme: ITheme }) => theme.text3};
                }
                .your-tier {
                    color: ${({ theme }: { theme: ITheme }) => theme.text1};
                }
            }
            .hint {
                margin-top: 24px;
                max-width: 400px;
                line-height: 28px;
                color: ${({ theme }: { theme: ITheme }) => theme.text1};
            }
            .btn-upgrade {
                margin-top: 50px;
                width: 124px;
                height: 40px;
            }
        }
        .right {
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        margin-top: 30px;
        .left-upgrade {
            .hint {
                margin-top: 24px;
                max-width: 400px;
            }
        }
        .upgrade-mobile {
            position: relative;
            .ant-image {
                position: absolute;
                left: 0;
                right: 0;
                width: 100%;
                .net-upgrade-mobile {
                    width: 100%;
                }
            }
        }
        .main-content .your-tier, .left-upgrade .hint{
            color: ${theme.text1};
        } 
        .box-upgrade-mobile {
            padding: 0 12px;
        }
        .main-content {
            text-align: center;
            .upgrade {
                font-family: 'Orbitron';
                font-style: normal;
                font-weight: 700;
                font-size: 22px;
                line-height: 32px;
                letter-spacing: 0.02em;
                color: ${theme.text3};
            }
            .your-tier {
                margin-left: 4px;
                font-family: 'Orbitron';
                font-style: normal;
                font-weight: 700;
                font-size: 22px;
                line-height: 32px;
                letter-spacing: 0.02em;
            }
        }
       
        .right {
            align-items: center;
            display: flex;
            svg {
                width: 100%;
            }
        }

        .btn-upgrade {
            margin: 40px auto 0;
            width: 100px;
            height: 32px;
        }
    `}
`;
